import mensalidadeService from '../../services/mensalidades/mensalidadeService';
import apiPagamentoBlob from '../../services/backAxiosPagamentoToken/apiAdyenBlob';
import { retornoHashValor } from '../cripotografia/hash';

export const gerarUrlBoleto = async faturas => {
    try {
        const inscricao = faturas[0].Inscricao;
        const value = somaValorTotalParcelas(faturas).toString().replace('.', '');
        const faturasString = makeParcelasStringPontoVirgula(faturas).replace(/\//g, '-');

        const url = retornoHashValor(process.env.REACT_APP_4);
        const linkBoleto = `${url}/boletoPdf/${inscricao}/${value}/${faturasString}`;

        const response = await apiPagamentoBlob.post(linkBoleto);

        return {
            readableStream: response.data,
            linkBoleto
        };
    } catch (err) {
        throw new Error(err);
    }
};

export const somaValorTotalParcelas = parcelas => {
    if (Array.isArray(parcelas)) {
        const todasParcelas = parcelas.map(parcela => Number(parcela.Valor));
        const valorTodasParcelas = todasParcelas.reduce((valorAnterior, valorAtual) => valorAnterior + valorAtual, 0);

        return valorTodasParcelas.toFixed(2);
    }
};

export const calcJurosParcelas = async parcelas => {
    try {
        const parcelasBody = makeBodyCalcJuros(parcelas);
        const parcelasCalculadas = await mensalidadeService.calculoJuros(parcelasBody);

        return parcelasCalculadas;
    } catch (err) {
        throw new Error(err);
    }
};

export const makeBodyCalcJuros = parcelas => {
    const parcelasFormatadas = parcelas.map(parcela => {
        const { Valor, Vencimento, Referencia } = parcela;

        return {
            Vencimento: formatDataEUA(Vencimento),
            Valor,
            Referencia
        };
    });

    return { parcelas: parcelasFormatadas };
};

export const formatDataEUA = data => {
    const dia = data.split('/')[0];
    const mes = data.split('/')[1];
    const ano = data.split('/')[2];

    return `${ano}-${mes}-${dia}`;
};

export const makeParcelasString = faturas => {
    let stringParcelas = '';
    let primeira = true;

    for (const fatura of faturas) {
        if (primeira) {
            stringParcelas = fatura.Referencia;
            primeira = false;
        } else {
            stringParcelas = `${stringParcelas}, ${fatura.Referencia}`;
        }
    }

    return stringParcelas;
};

export const makeParcelasStringPontoVirgula = faturas => {
    let referencia = '';
    let primeiro = true;

    for (const fatura of faturas) {
        if (primeiro) {
            referencia = fatura.Referencia;
            primeiro = false;
        } else {
            referencia = `${referencia};${fatura.Referencia}`;
        }
    }

    return referencia;
};
